import { useState } from "react"

import RecaptchaStateProvider from "../signUp/RecaptchaStateProvider"
import { CoreFastSignupComponent } from "./CoreFastSignupComp"

interface IFastSignUpComponent {
  isOpen: boolean
  setOpenState: (val: boolean) => void
  title: string
  phoneNumberToBePrefilled?: string
  showTitleAsIs?: boolean
  cannotDismissPopup?: boolean
  from?: "createEvent" | "joinEvent"
  verifyEmail?: boolean
}

const FastSignUpComponent = ({
  isOpen,
  setOpenState,
  title = 'Join "The coolest pool party"',
  phoneNumberToBePrefilled,
  showTitleAsIs = false,
  cannotDismissPopup = false,
}: IFastSignUpComponent) => {
  const [step, setStep] = useState(1)

  return (
    <RecaptchaStateProvider>
      <CoreFastSignupComponent
        isOpen={isOpen}
        step={step}
        setStep={setStep}
        setOpenState={setOpenState}
        title={title}
        phoneNumberToBePrefilled={phoneNumberToBePrefilled}
        showTitleAsIs={showTitleAsIs}
        cannotDismissPopup={cannotDismissPopup}
      />
    </RecaptchaStateProvider>
  )
}

export default FastSignUpComponent
